"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowH1H4 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
// same as RowH2Lead, but bigger
var RowH1H4 = function (_a) {
    var heading = _a.heading, children = _a.children, _b = _a.mb, mb = _b === void 0 ? '11' : _b;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-md-8 mx-auto text-center" }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ className: (0, classnames_1.default)('lh-1-5', children ? 'mb-5' : "mb-".concat(mb)) }, { children: heading })), children && (0, jsx_runtime_1.jsx)("h4", __assign({ className: "opacity-70 lh-1-5 mb-".concat(mb) }, { children: children }))] })) })));
};
exports.RowH1H4 = RowH1H4;
